import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Ohio">
                <h1>Mobile App Development Company in Ohio</h1>
              </div>
              <p className="main_para">
                TekRevol is a well-known name in the mobile app development
                sector. We have served multiple businesses from different
                industries globally to digitize their operations while scaling
                up their digital presence. Being a reliable mobile app
                development company in Ohio, we streamline the business
                processes using the latest technologies & frameworks. Our main
                focus is to build full-fledged digital solutions for our clients
                that enable them to stand out in their highly competitive
                industry.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
